//////////////////////////////////////////////////////////////////////
//
//  10/15/18
//  src/containers/MusicData.js
//
//  This file will contain all the 'canned' Music Data.
//

//
//  This is the raw Music data.
//
const MusicData = [
 {
   miles : "2.1  mi.",
   name  : "Good Rust",
   music : true,
   food  : false,
   happy : false,
   notes : false,
   board : true,
   line1 : "Oct. 26th and 27th",
   line2 : "Apache Lake Resort",
   line3 : "Fri. and Sat. (11:00 AM)",
   line4 : "Come On Down, Music All Day!",
   mpop  : "Oct. 26th and 27th, Apache Lake Resort",
   fpop  : "",
   hpop  : "",
   addr  : "",
 },
 {
   miles : "4.4  mi.",
   name  : "Too Many Zooz",
   music : true,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "Too Many Zooz",
   line2 : "",
   line3 : "-->>- 8PM Tonight -<<--",
   line4 : "Crescent Ballroom",
   mpop  : "Tonight 8:00 PM, Crescent Ballroom",
   fpop  : "",
   hpop  : "",
   addr  : "http://toomanyzooz.com/",
 },
 {
   miles : "5.2  mi.",
   name  : "Soul Power Band",
   music : true,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "Soul Power Band",
   line2 : "House Band at Char's",
   line3 : "Every Fri. and Sat.",
   line4 : "Once at Month at The Rhythm Room",
   mpop  : "Char's House Band",
   fpop  : "",
   hpop  : "",
   addr  : "https://soulpowerbandaz.com/",
 },
 {
   miles : "6.1  mi.",
   name  : "Kristy Dee",
   music : true,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "Kristy Dee",
   line2 : "Tonight",
   line3 : "Bogey's Grill 6-9PM",
   line4 : "Guadalupe and Rural",
   mpop  : "Tonight at Bogey's Grill, 6-9PM",
   fpop  : "",
   hpop  : "",
   addr  : "http://www.kristydee.com/",
 },
 {
   miles : "6.7  mi.",
   name  : "Mogollon",
   music : true,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "-->> Mogollon <<--",
   line2 : "At Casion Arizona",
   line3 : "10/24/18",
   line4 : "8:00 PM",
   mpop  : "Rockin' the Country... With Attitude!",
   fpop  : "",
   hpop  : "",
   addr  : "https://www.mogollonband.com/",
 },
 {
   miles : "7.0  mi.",
   name  : "Lost In The Sun",
   music : true,
   food  : false,
   happy : false,
   notes : false,
   board : true,
   line1 : "Lost In The Sun",
   line2 : "Main State",
   line3 : "Local First Az Fall Festival",
   line4 : "",
   mpop  : "Vinyl Record Release Show 11/09/18",
   fpop  : "",
   hpop  : "",
   addr  : "",
 },
 {
   miles : "8.9  mi.",
   name  : "Still Corners",
   music : true,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "Still Corners",
   line2 : "Rebel Lounge",
   line3 : "10/29/18",
   line4 : "",
   mpop  : "New Album, 08/17/18",
   fpop  : "",
   hpop  : "",
   addr  : "https://www.stillcorners.com/",
 },
 {
   miles : "12.4  mi.",
   name  : "Shannon And the Clams",
   music : true,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "Shannon And the Clams",
   line2 : "Crescent Room",
   line3 : "Thursday Oct. 11th",
   line4 : "Phoenix",
   mpop  : "Come down to the Crescent Room, Oct 11th",
   fpop  : "",
   hpop  : "",
   addr  : "http://shannonandtheclams.com/",
 },
 {
   miles : "15.5  mi.",
   name  : "Power Trip",
   music : true,
   food  : false,
   happy : false,
   notes : false,
   board : true,
   line1 : "Power Trip",
   line2 : "New Song:",
   line3 : "Hornet's Nest",
   line4 : "Rebel Lounge 11/02/18 8PM",
   mpop  : "Rebel Lounge 11/02/18 8PM",
   fpop  : "",
   hpop  : "",
   addr  : "",
 },
 {
   miles : "16.0  mi.",
   name  : "Thaddeus Rose Band",
   music : true,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "Thaddeus Rose Band",
   line2 : "Sat. Oct. 13th, 7-9PM",
   line3 : "Cactus Jack's Bar and Grill",
   line4 : "4747 E Elliot Rd. Phx, 85044",
   mpop  : "Cactus Jack's Bar, Wed. Oct. 31th, Come down and dress up in a costume!",
   fpop  : "",
   hpop  : "",
   addr  : "https://thaddeusrose.com/",
 },
];

export default MusicData;



// WEBPACK FOOTER //
// ./src/components/MusicData.js